import { useCallback, useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { CURRENCIES, GMS_STEPS, PATHS, TRANSACTION_STATUS, TRANSACTION_TYPES, WEIGHT_UNITS } from '../../utils/constant';
import { IPageState, PageContext } from '../../contexts/PageContext'
import Inbound from '../$Inbound';
import Summary from '../$Summary';
import { formatDate, getFormattedCurrency, getThreePointNumber, getTwoPointNumber, objToArray } from '../../utils/helpers';
import { TransactionContext } from '../../contexts/TransactionContext';
import { AuthContext } from '../../contexts/AuthContext';
import useService from '../../hooks/useService';
import SelectCustomer from '../$SelectCustomer';
import { TTransactionBasic } from '../../Models/Transactions';
import {getLotDetails, getTransaction as getTransactionService} from '../../services/Transactions'
import { CustomerContext } from '../../contexts/CustomerContext';
import HighlightsCardAndCustomerDetails from '../custom/HighlightsCardAndCustomerDetails';

export type TGMSSectionKeys = 'INBOUND' | 'SUMMARY'

const PAGE_INFO: IPageState = {
    title: 'GMS',
    breadcrumbs: objToArray(GMS_STEPS).map(item => ({ path: item.key, label: item.value })),
    currentPage: GMS_STEPS.INBOUND,
    path: PATHS.GMS
}

type TGMSSummaryKeys = 
'customerId' 
| 'customerName' 
| 'pvcName' 
| 'transactionDate' 
| 'inboundMetal' 
| 'totalWBMGold'
| 'totalWAMGold'
| 'totalWAMTGold'
| 'settlementFineWeightGold'
| 'totalTaxValue'
| 'totalCharges'
| 'roundingRs'
| 'totalValue'
| 'totalMetalReturnNetWeightGold'

const SUMMARY_DETAILS: {id: TGMSSummaryKeys, label: any, value: any}[] = [
    {
        id: 'customerId',
        label:"Customer Id",
        value : ""
    },
    {
        id:"customerName",
        label:"Customer Name",
        value : ""
    },
    {
        id:"pvcName",
        label:"PVC Name",
        value : ""
    },
    {
        id:"transactionDate",
        label:"Transaction Date",
        value : ""
    },
    {
        id:"inboundMetal",
        label:"Inbound Metal",
        value : ""
    },
    {
        id:'totalWBMGold',
        label:"Total WBM",
        value : ''
    },
    {
        id:'totalWAMGold',
        label:"Total WAM",
        value : ''
    },
    {
        id:'totalWAMTGold',
        label:"Total WAMT",
        value : ''
    },
    {
        id:'settlementFineWeightGold',
        label:"Settlement Fine Wt. Gold",
        value : ''
    },
    {
        id:'totalMetalReturnNetWeightGold',
        label:"Total Metal Return Net Wt. Gold",
        value : ''
    },
    {
        id:'totalTaxValue',
        label:"Total Tax Value Rs.",
        value : ''
    },
    {
        id:'totalCharges',
        label:"Total Charges Rs.",
        value : ''
    },
    // {
    //     id:'roundingRs',
    //     label:"Rounding Rs.",
    //     value : ''
    // },
    // {
    //     id:'totalValue',
    //     label:"Grand Total Rs.",
    //     value : ''
    // },
]

const Container = styled.div`
    width: 100%;
`

const getPageInfo = (section: TGMSSectionKeys) => {
    const pageInfo = { ...PAGE_INFO, currentPage: section || 'INBOUND' }
    return pageInfo
}

const GMS = () => {

    const { setPageState } = useContext(PageContext)
    const [searchParams] = useSearchParams()
    const { 
        setTransactionInfo, meltingLot,
        transactionInfo: { transactionType, globalTransactionNumber, status,updatedAt }, 
        pvcCenterDetails, inboundDetails, resetOrder, setCapturedSteps, physicalOrder
    } = useContext(TransactionContext)
    const { user } = useContext(AuthContext)
    const { customerConfig } = useContext(CustomerContext)
    const { id } = useParams()
    const { execute } = useService()
    const navigate = useNavigate()
    const step = searchParams.get('section')

    const cancelTransactionHandler = (transactionId:string) => {
        navigate(PATHS.PVC_TRANSACTIONS)
    }

    useEffect(() => {
        setPageState(getPageInfo(step as TGMSSectionKeys))
    }, [step])

    useEffect(()=>{
        resetOrder()

        if (id) {
            getTransaction()
        }
        else {
        setTransactionInfo({
            currency: CURRENCIES.INR,
            pvcCenterId: user.centerId!,
            status: TRANSACTION_STATUS.INBOUND_INITIATED,
            transactionType: TRANSACTION_TYPES.GMS,
            weightUOM: WEIGHT_UNITS.GM,
        } as TTransactionBasic)
    }
    },[])


    const getTransaction = async () => {
        const { data } = await execute(() => getTransactionService({ globalTransactionNumber: id!, transactionType }))
        if(data?.status === TRANSACTION_STATUS.COMPLETED) await execute(()=> getLotDetails({globalTransactionNumber:data?.globalTransactionNumber!}))
        if (data !== null) {
            switch (data.status) {
                case TRANSACTION_STATUS.INBOUND_INITIATED:
                    navigate(PATHS.GMS + '/' + id + '?section=INBOUND')
                    break;
                case TRANSACTION_STATUS.COMPLETED:
                case TRANSACTION_STATUS.PENDING_CANCELLATION:
                case TRANSACTION_STATUS.CANCELLED:
                    setCapturedSteps(['INBOUND'])
                    navigate(PATHS.GMS + '/' + id + '?section=SUMMARY')
                    break;
                default:
                    navigate(PATHS.GMS + '/' + id + '?section=INBOUND')
                    break;
            }
        }
    }

    const getSummary = () => {
        let totalWBM = 0
        let totalWAM = 0
        let totalWAMT = 0
        let settlementFineWeightGold = 0
        let totalMetalReturnNetWeightGold = 0
        console.log('in summary...', meltingLot)
        meltingLot.forEach(lot => {
            console.log('lot in summary...')
            totalWBM += lot.netWeight
            totalWAM += lot.weightAfterMelting
            totalWAMT += lot.wamt
            settlementFineWeightGold += lot.fineWeightToReturn
            totalMetalReturnNetWeightGold += lot.finalSettlementNetWeight
        })
        let totalTaxValue = 0
        physicalOrder.taxes?.forEach((tax) => {
            totalTaxValue += tax.taxAmount
        })
        let totalCharges = 0
        physicalOrder.charges?.forEach((charge) => {
            totalCharges += charge.preTaxAmount
            totalTaxValue += charge.postTaxAmount - charge.preTaxAmount
        })
        const roundingRs = getTwoPointNumber((Math.round(physicalOrder.totalPrice || 0) - (physicalOrder.totalPrice || 0)) ?? 0)
        return SUMMARY_DETAILS.map(field => {
            switch (field.id) {
                case 'customerId':
                    field.value = customerConfig.customerRefNo
                    break;
                case 'customerName':
                    field.value = customerConfig.fullName
                    break;
                case 'pvcName':
                    field.value = pvcCenterDetails.name
                    break;
                case 'inboundMetal':
                    field.value = physicalOrder.totalGoldWeight + ' gm'
                    break;
                case 'transactionDate':
                    field.value = updatedAt ? formatDate(updatedAt) : ''
                    break;
                case 'totalWBMGold':
                    field.value = getThreePointNumber(totalWBM)
                    break;
                case 'totalWAMGold':
                    field.value = getThreePointNumber(totalWAM)
                    break;
                case 'totalWAMTGold':
                    field.value = getThreePointNumber(totalWAMT)
                    break;
                case 'settlementFineWeightGold':
                    field.value = getThreePointNumber(settlementFineWeightGold)
                    break;
                case 'totalMetalReturnNetWeightGold':
                    field.value = getThreePointNumber(totalMetalReturnNetWeightGold)
                    break;
                case 'totalTaxValue':
                    field.value = getFormattedCurrency(getTwoPointNumber(totalTaxValue))
                    break;
                case 'totalCharges':
                    field.value = getFormattedCurrency(getTwoPointNumber(totalCharges))
                    break;
                case 'roundingRs':
                    field.value = getFormattedCurrency(getTwoPointNumber(roundingRs))
                    break;
                case 'totalValue':
                    field.value = getFormattedCurrency(getTwoPointNumber(physicalOrder.totalPrice || 0))
                    break;
            }
            return field
        })
    }

    const PageContent = useCallback(() => {
        switch (step as TGMSSectionKeys) {
            case 'INBOUND':
                return <Inbound nextButtonLable='Next (Summary)' nextSection='SUMMARY' path={PATHS.GMS} />

            case 'SUMMARY':
                return <Summary path={PATHS.GMS} prevSection='INBOUND' transitionHistory={[]} summaryDetails={getSummary()} />

            default:
                return <SelectCustomer path={PATHS.GMS} nextSection='INBOUND' />
        }
    }, [step, inboundDetails])
    


    return (
        <Container>
            { id ? <HighlightsCardAndCustomerDetails
                        customerConfig={customerConfig}
                        globalTransactionNumber={globalTransactionNumber as string}
                        status={status}
                        inboundId={inboundDetails.id}
                        onSuccessCancelTransaction={cancelTransactionHandler}
                        transactionType={transactionType}
                    /> 
                : <></>
             }
            <PageContent />
        </Container>
    )
}


export default GMS